import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { servicosModuleName, servicosStorage } from "../shared/data.service";
import { Servico } from "../shared/servico.model";
import { editRoute, newRoute, configuracaoModuleName } from "../../../shared/services/data.service";
import { ServicoNavigationService } from "../shared/servico-navigation.service";
import { ServicoApiService } from "../shared/servico-api.service";
import { UtilService } from "../../../shared/services/util.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { ServicoService } from "../shared/servico.service";
import { ManutencaoService } from "../../shared/manutencao.service";
import { manutencoesModuleName } from "../../shared/data.service";
import {MaterialServicoApiService} from "../../../almoxarifado/materiais/material-servico/shared/material-servico-api.service";

@Component({
    template: require('./servico-form.component.html'),
    styles: [require('./servico-form.component.css')]
})
export class ServicoFormComponent implements OnInit {
    servicosModule: any = servicosModuleName;
    module: any = manutencoesModuleName;
    configuracaoModule: any = configuracaoModuleName;
    formObject: Servico = new Servico();
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;
    materiais: any[] = [];

    form: FormGroup;
    valor = new FormControl('', Validators.required);
    ativo = new FormControl('');
    descricao = new FormControl('', Validators.required);

    private returnToOtherForm: boolean = false;
    private otherForm: string;
    private responseServico: any;

    constructor(
        private _route: ActivatedRoute,
        private _servicoNavigationService: ServicoNavigationService,
        private _servicoApiService: ServicoApiService,
        private _utilService: UtilService,
        private _autocompleteService: AutoCompleteService,
        private _servicoService: ServicoService,
        private _manutencaoService: ManutencaoService,
        private _materialServicoApiService: MaterialServicoApiService,
        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            descricao: this.descricao,
            valor: this.valor
        });
    }

    ngOnInit() {
        this.isNewAutoComplete();
    }

    clickGoToList() {
        this.goToList();
    }

    clickGoToConfig() {
        this._manutencaoService.goToSetting();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    keyupCurrency(start?: boolean) {
        var valor: number = this._utilService.currencyFormat(this.formObject.valor, start);
        if (valor) {
            this.formObject.valor = valor;
        }
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            this.btnSaveDisabled = true;
            var object:any = this._utilService.cloneObject(this.formObject);

            if (object.valor) {
                object.valor = this._utilService.getCurrency(object.valor);
            }

            object.Materiais = [];
            this.materiais.forEach(function(item: any) {
                item.materialId = item.material.id;
                delete item['material'];
                object.Materiais.push(item);
            });

            if (this.formObject.id) {
                this.onEditServico(object);
            } else {
                this.onAddServico(object);
            }
        }
    }

    private onAddServico(object: Servico) {
        this._servicoApiService.onPost(object, this.onDone);
    }

    private onEditServico(object: Servico) {
        this._servicoApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            this.responseServico = Response;

            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }

            this.toLeaveHere();

        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum serviço encontrado com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._servicoApiService.onGetById(id, onDone);
    }

    private getMateriais(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.materiais = Response;
            }
        }.bind(this));

        this._materialServicoApiService.onGetByServico(id, onDone);
    }

    private testSession() {
        var id: number;
        var session: any = this._servicoService.getSessionStorage();
        this._servicoService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            this.setModelToForm();
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setModelToForm() {
        if (this.formObject.id) {
            this.keyupCurrency(true);
        }
    }

    private toLeaveHere() {
        if (this.returnToOtherForm) {
            this._servicoService.returnToOtherForm(this.otherForm, this.responseServico);
        } else {
            this.goToList();
        }
    }

    private goToList() {
        this._servicoNavigationService.goToList();
    }

    private isNewAutoComplete() {
        var newAutoComplete: any = this._autocompleteService.getSessionStorage(servicosStorage);
        if (newAutoComplete) {
            this.returnToOtherForm = true;
            this.otherForm = newAutoComplete.form;
            this.formObject.descricao = newAutoComplete.descricao;

            this.setActionTitle(this.formObject.id);
        } else {
            //retornando de um cadastro
            this.testSession();
        }
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRoute;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
        this.getMateriais(id);
    }

    private setNewNormal() {
        //se tiver alguma configuração inicial de um cadastro novo
    }

    private setEditSession() {
        //qndo retornou para continuar a edição
    }

    private setNewSession() {
        //qndo retornou para continuar o cadastro
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/servicos/servico-form/servico-form.component.ts
 **/